export default __webpack_public_path__ + "static/media/ProductReview.f02e5acd.svg";